import moment from 'moment';
import DatatableComponent from 'helpers/DatatableComponent';
import React, { useEffect, useState } from "react";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import { connect } from "react-redux";
import { getDuration } from "../../store/helpers/common_functions";
import StatusLayout from "components/Status";
import { Button, Link, Paper, Dialog, DialogTitle, DialogContent } from "@mui/material";


const ViewSubmittedProjectReports = ({ location, SetSelectedMenu, loggedUser }) => {
    const [list, setList] = React.useState([]);
    const [count, setCount] = React.useState(0);
    const [selectedResource] = useState("");

    const { startDate, endDate, reportId } = location.state || {};

    const period = {
        startDate: startDate ? moment(startDate) : moment().startOf("W"),
        endDate: endDate ? moment(endDate) : moment().endOf("W"),
    };
    const [dataToEdit, setDataToEdit] = useState({});
    const [addNew, setAddNew] = useState(false);

    useEffect(() => {
        SetSelectedMenu({
            menu: "project-reports",
            title: "Project Report",
        });
    }, []);

    const columns = [
        {
            name: "code",
            label: "Code"
        },
        {
            name: "name",
            label: "Name",
        },
        {
            name: "program",
            label: "Program Name"
        },
        {
            name: "startDate",
            label: "Start Date",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => moment(value).format("DD/MM/yyyy") ?? "",
            },
        },
        {
            name: "endDate",
            label: "End Date",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => moment(value).format("DD/MM/yyyy") ?? "",
            },
        },
        {
            name: "impact",
            label: "Impact"
        },
        {
            name: "performance",
            label: "Performance",
        },
        {
            name: "challenge",
            label: "Challenge/ Comment",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta) => (
                    <div>
                        {value ? (
                            <Link
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    const projectName = tableMeta.rowData[1];
                                    setDataToEdit({ challenge: value, name: projectName });
                                    setAddNew(true);
                                }}
                                sx={{ textDecoration: 'underline', color: 'blue', cursor: 'pointer' }}
                            >
                                View Challenge
                            </Link>
                        ) : (
                            <span style={{ color: '#888' }}>No Challenge</span>
                        )}
                        {addNew && dataToEdit.challenge === value && (
                            <Dialog
                                open={addNew}
                                maxWidth="xs"
                                fullWidth
                                onClose={() => setAddNew(false)}
                                PaperProps={{
                                    style: { padding: '1rem', borderRadius: '8px' },
                                }}
                            >
                                <DialogTitle style={{ fontSize: '1rem' }}>
                                    <b>{dataToEdit.name ? `Challenge for Project: ${dataToEdit.name} ` : "Challenge"}</b>
                                </DialogTitle>
                                <DialogContent>
                                    <div
                                        dangerouslySetInnerHTML={{ __html: dataToEdit.challenge }}
                                        style={{ fontSize: '0.9rem', color: '#333' }}
                                    />
                                </DialogContent>
                                <div style={{ textAlign: 'right', marginTop: '1rem' }}>
                                    <Button
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setAddNew(false);
                                        }}
                                        sx={{
                                            color: 'primary.main',
                                            textTransform: 'none',
                                            fontWeight: 'normal',
                                        }}
                                    >
                                        Close
                                    </Button>
                                </div>
                            </Dialog>
                        )}
                    </div>
                ),
            },
        },
        {
            name: "status",
            label: "Status",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (status) => {
                    let color =
                        status === "completed"
                            ? "success"
                            : status === "canceled"
                                ? "error"
                                : status === "pending review"
                                    ? "text-green-500"
                                    : status === "under review"
                                        ? "bg-secondary"
                                        : status === "missing information"
                                            ? "bg-black-500"
                                            : status === "forwarded"
                                                ? "bg-primary"
                                                : "info";
                    return (
                        <span
                            style={{ fontSize: "0.85rem" }}
                        >
                            <StatusLayout status={status} />
                        </span>

                    );
                },
            },
        },

    ];
    return (
        <div>
            <DatatableComponent
                columns={columns}
                order={location.state?.order}
                url={`/api/report/projects/list-project_reports/?count=${count}&resourceId=${selectedResource}&reportId=${reportId}${period.startDate && period.endDate ? `&period=${JSON.stringify(period)}` : ""}`}

                processData={(data) => {
                    setList(data.data);
                    return data;
                }}
                title={
                    <div className="w-1/3 flex gap-2">
                        <span>
                            <div className="flex justify-center flex-col gap-2 p-4">
                                <div className="flex flex-col md:flex-row gap-2">
                                    <div className="md:w-full w-1/6 mb-2 xl:mb-0">
                                        <Paper
                                            component="form"
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                width: "100%",
                                            }}
                                        >
                                            <label
                                                style={{
                                                    minWidth: "80px",
                                                    maxWidth: "80px",
                                                    textAlign: "center",
                                                }}
                                                className="min-w-24 text-[#054163] text-ml px-3 py-1 placeholder-blueGray-300 bg-white rounded shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                            >
                                                From
                                            </label>
                                            <input
                                                className="px-3 py-1 placeholder-blueGray-300 border-0 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                                placeholder="Search by year"
                                                value={
                                                    Date.parse(period?.startDate)
                                                        ? moment(period?.startDate).format("YYYY-MM-DD")
                                                        : ""
                                                }
                                                type="date"
                                                max={period.endDate}
                                                maxLength={4}
                                                minLength={4}
                                                disabled
                                            />
                                        </Paper>
                                    </div>
                                    <div className="md:w-full w-1/6 mb-12 xl:mb-0">
                                        <Paper
                                            component="form"
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                width: "100%",
                                            }}
                                        >
                                            <label className="text-[#054163] text-md max-w-24 px-3 py-1 bg-white rounded shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150">
                                                To
                                            </label>
                                            <input
                                                className="px-3 py-1 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                                placeholder="Search by year"
                                                value={
                                                    Date.parse(period?.endDate)
                                                        ? moment(period?.endDate).format("YYYY-MM-DD")
                                                        : ""
                                                }
                                                min={moment(period?.startDate).format("YYYY-MM-DD")}
                                                type="date"
                                                maxLength={4}
                                                minLength={4}
                                                disabled
                                            />
                                        </Paper>
                                    </div>
                                </div>
                            </div>
                        </span>

                    </div>
                }
            />
        </div>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewSubmittedProjectReports);
